export default __webpack_public_path__ + "static/media/logo-facebook.e558b552.svg";